import type { Fetcher } from "react-query-kit";
import { createInfiniteQuery, createQuery } from "react-query-kit";

import type { IPickCollectionQuery } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient } from "../../clients";

import type { IFacultyAcademicGroup } from "./routeType";

import { infiniteHelper } from "@utils";

const { key, getPath } = getApi("faculties.academicGroup.getAll");

type IExtractedRouteType =
  IFacultyAcademicGroup["academicGroupCollectionRetrieve"];

export type IGetAllFacultyAcademicGroups =
  IPickCollectionQuery<IExtractedRouteType>;

const getAllFacultyAcademicGroups: Fetcher<
  IGetAllFacultyAcademicGroups["response"],
  IGetAllFacultyAcademicGroups["variables"],
  number
> = ({ facultyId, ...params }, { pageParam }) => {
  return axiosClient.get(getPath({ facultyId }), {
    params: { ...params, page: pageParam ?? params?.page },
  });
};

export const useGetAllFacultyAcademicGroups = createQuery({
  queryKey: [key],
  fetcher: getAllFacultyAcademicGroups,
});

export const useGetAllFacultyAcademicGroupsInfinite = createInfiniteQuery({
  queryKey: [`infinite.${key}`],
  fetcher: getAllFacultyAcademicGroups,
  ...infiniteHelper,
});
